import { Trans, useTranslation } from 'react-i18next'
import _isEmpty from 'lodash/isEmpty'
import cn from 'clsx'

import getFormattedEmissionsValue from '../../utils/data/get_formatted_emissions_value'
import { type Emissions } from '../../types/data'

import './style.scss'

const CLASS_NAME = 'cst-map-polygon-tooltip'

type Props = {
  emissions: Emissions
}

export default function MapPolygonTooltip({ emissions }: Props) {
  const { t } = useTranslation()
  const {
    feature: {
      properties: {
        name: featureName,
        site_name: featureSiteName,
        area: featureArea
      }
    },
    totalIntensity,
    total
  } = emissions

  const nameFieldLabel = _isEmpty(featureName)
    ? t('map_emissions_marker.site_name_field_label')
    : t('map_emissions_marker.name_field_label')

  const nameFieldValue = _isEmpty(featureName) ? featureSiteName : featureName
  const featureTotalNEE = getFormattedEmissionsValue(total)
  const featureTotalIntensity = getFormattedEmissionsValue(
    totalIntensity ?? 0,
    true
  )

  const featureAreaLabel =
    featureArea > 1000
      ? `${(featureArea / 1000).toFixed(2)} kHa`
      : `${featureArea.toFixed(2)} Ha`

  return (
    <div className={CLASS_NAME}>
      <div className={`${CLASS_NAME}-wrapper`}>
        <ul>
          {!_isEmpty(nameFieldValue) && (
            <li>
              <p>{nameFieldLabel}</p>
              <p>{nameFieldValue}</p>
            </li>
          )}
          <li>
            <p>
              <Trans i18nKey="map_emissions_marker.area_field_label">
                Area
              </Trans>
            </p>
            <p>{featureAreaLabel}</p>
          </li>
        </ul>
        <ul>
          {featureTotalIntensity !== null && (
            <li>
              <p>
                <Trans i18nKey="map_emissions_marker.intensity_field_label">
                  Intensity
                </Trans>
              </p>
              <p
                className={cn({
                  positive: totalIntensity !== null && totalIntensity > 0,
                  negative: totalIntensity !== null && totalIntensity < 0
                })}
              >
                {featureTotalIntensity}
              </p>
            </li>
          )}
          <li>
            <p>
              <Trans i18nKey="map_emissions_marker.nee_field_label">
                Total NEE
              </Trans>
            </p>
            <p
              className={cn({
                positive: total > 0,
                negative: total < 0
              })}
            >
              {featureTotalNEE}
            </p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export { CLASS_NAME }
